var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_210_956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8023 7.52154H8.69767V10.7751H13.3628C12.9279 12.8421 11.1093 14.0287 8.69767 14.0287C5.85116 14.0287 3.55814 11.8086 3.55814 9.05264C3.55814 6.29666 5.85116 4.07657 8.69767 4.07657C9.92326 4.07657 11.0302 4.49762 11.9 5.18662L14.4302 2.73686C12.8884 1.43542 10.9116 0.631592 8.69767 0.631592C3.87442 0.631592 0 4.38279 0 9.05264C0 13.7225 3.87442 17.4737 8.69767 17.4737C13.0465 17.4737 17 14.4115 17 9.05264C17 8.55504 16.9209 8.01915 16.8023 7.52154Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_210_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.790527 14.0287V4.07654L5.9304 9.05261L-0.790527 14.0287Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_210_956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8023 7.52154H8.69767V10.7751H13.3628C12.9279 12.8421 11.1093 14.0287 8.69767 14.0287C5.85116 14.0287 3.55814 11.8086 3.55814 9.05264C3.55814 6.29666 5.85116 4.07657 8.69767 4.07657C9.92326 4.07657 11.0302 4.49762 11.9 5.18662L14.4302 2.73686C12.8884 1.43542 10.9116 0.631592 8.69767 0.631592C3.87442 0.631592 0 4.38279 0 9.05264C0 13.7225 3.87442 17.4737 8.69767 17.4737C13.0465 17.4737 17 14.4115 17 9.05264C17 8.55504 16.9209 8.01915 16.8023 7.52154Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_210_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.790527 4.07649L5.9304 9.05257L8.69785 6.71764L18.1862 5.22482V-0.134033H-0.790527V4.07649Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_210_956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8023 7.52154H8.69767V10.7751H13.3628C12.9279 12.8421 11.1093 14.0287 8.69767 14.0287C5.85116 14.0287 3.55814 11.8086 3.55814 9.05264C3.55814 6.29666 5.85116 4.07657 8.69767 4.07657C9.92326 4.07657 11.0302 4.49762 11.9 5.18662L14.4302 2.73686C12.8884 1.43542 10.9116 0.631592 8.69767 0.631592C3.87442 0.631592 0 4.38279 0 9.05264C0 13.7225 3.87442 17.4737 8.69767 17.4737C13.0465 17.4737 17 14.4115 17 9.05264C17 8.55504 16.9209 8.01915 16.8023 7.52154Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_210_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.790527 14.0286L11.0699 5.22482L14.1932 5.60759L18.1862 -0.134033V18.2392H-0.790527V14.0286Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_210_956",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 18
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8023 7.52154H8.69767V10.7751H13.3628C12.9279 12.8421 11.1093 14.0287 8.69767 14.0287C5.85116 14.0287 3.55814 11.8086 3.55814 9.05264C3.55814 6.29666 5.85116 4.07657 8.69767 4.07657C9.92326 4.07657 11.0302 4.49762 11.9 5.18662L14.4302 2.73686C12.8884 1.43542 10.9116 0.631592 8.69767 0.631592C3.87442 0.631592 0 4.38279 0 9.05264C0 13.7225 3.87442 17.4737 8.69767 17.4737C13.0465 17.4737 17 14.4115 17 9.05264C17 8.55504 16.9209 8.01915 16.8023 7.52154Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_210_956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1858 18.2392L5.93003 9.05261L4.34863 7.90429L18.1858 4.07654V18.2392Z",
    fill: "#4285F4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.831955ecf8677b6f0d7981bb9c67866d.svg";
export { ForwardRef as ReactComponent };